export function authenticationActionError(
  cause: unknown,
  fallback: string,
): string {
  return cause instanceof Error && cause.message.length > 0
    ? cause.message
    : fallback;
}

export function relativeSessionActivity(
  unixMs: number,
  nowUnixMs: number,
): string {
  const elapsedMinutes = Math.max(0, Math.floor((nowUnixMs - unixMs) / 60_000));
  if (elapsedMinutes < 1) return "just now";
  if (elapsedMinutes < 60) return `${elapsedMinutes}m ago`;
  const elapsedHours = Math.floor(elapsedMinutes / 60);
  if (elapsedHours < 24) return `${elapsedHours}h ago`;
  return `${Math.floor(elapsedHours / 24)}d ago`;
}
